var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.698 18.342a16.076 16.076 0 001.878-.212V24H7.698v-5.658zM0 24h1.878v-5.633H0V24zm3.85-5.633V24h1.877v-5.633H3.849zM19.198 24h1.877V9.728a15.973 15.973 0 01-1.877 2.818V24zm-3.85 0h1.878v-9.46c-.593.505-1.22.964-1.877 1.376V24zm-3.848-6.329V24h1.877v-7.032a16.075 16.075 0 01-1.878.703zM20.077 0l-3.983 3.983 1.328 1.328 1.65-1.651c-.694 6.153-5.93 10.952-12.266 10.952H0v1.877h6.806c3.8 0 7.371-1.48 10.058-4.166A14.115 14.115 0 0020.97 3.55L22.7 5.277l1.328-1.327L20.077 0z",
    fill: "url(#increase_svg__paint0_linear_1759_54553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "increase_svg__paint0_linear_1759_54553",
    x1: 12.013,
    y1: 0,
    x2: 12.013,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AE9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/increase.85e4f8b27c8a9ab310ff7bb50a7d80dc.svg";
export { SvgIncrease as ReactComponent };